import { useEffect } from 'react';

/**
 * Redirect a legacy URL to a homepage anchor with reliable hash scroll.
 * Uses window.location.replace so the browser natively handles the #anchor scroll
 * and the wrong URL is removed from history.
 */
const HashRedirect = ({ to = '/#servizi' }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

export default HashRedirect;
